// extracted by mini-css-extract-plugin
export default {"home":"home_home__lWdS8","lead":"home_lead__5gJEm","tagline":"home_tagline__9WWa2","body":"home_body__uCOj+","cta":"home_cta__LiCIa"};